import {Component, Input, OnInit} from '@angular/core';
import {ArticleNews} from "../model/ArticleNews";
import {ActivatedRoute} from "@angular/router";
import {DocumentService} from "../service/document-service";

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {

  @Input()
  public articleNews: ArticleNews = undefined;

  constructor(private route: ActivatedRoute,
              private documentService: DocumentService) {
  }

  ngOnInit(): void {
    if (!this.articleNews) {
      this.route.params.subscribe(params => {
        const storyId = params['storyId'];
        this.documentService.getMgnDoc(storyId).subscribe({
          next: article => {
            this.articleNews = article;
          }
        })
      });
    }
  }
}
